import React, { useState, useEffect } from "react";
import MofService from "../../../../services/mof";
import SpinnerLoader from '../../../components/general/SpinnerLoader';
import BodyUserToFolder from "../BodyUserToFolder";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Button, } from '@mui/material';
import { CODES } from "../../../../utils/responseCodes";
import { Select, Input } from "antd";
import { Toast } from "../../../../utils/alerts";
import _ from "lodash";


const { Option } = Select;

const AddUserToFolderInfo = ({ getUsersByCarpeta,carpetaSeleccionada, usuarioLA, setUsuarioLA, infoUsuarioLA, setInfoUsuarioLA, usuarioCarpeta, setUsuarioCarpeta,usuariosAgregados, setUsuariosAgregados  }) => {

    const [openModalLoader, setOpenModalLoader] = useState(true);
   
    useEffect(() => {
        init();
    }, []);

    const init = () => {
        Promise.all([getUsuarioLA()]).then(() =>
            setOpenModalLoader(false)
        );
    };

    const getUsuarioLA = async () => {
        setOpenModalLoader(true);
        try {
            const result = await MofService.getUsuarioLA();
            if (result.status === CODES.SUCCESS_200) {
                if (result?.data?.length === 0) {
                    Toast.fire({
                        icon: "info",
                        title: "No se encontraron usuarios",
                    });
                    return;
                }
                result.data?.forEach((element) => {
                    element.id = element.usuario.id_usuario;
                    element.value = element.usuario.id_usuario;
                    element.user = element.usuario.usuario
                    element.label = element.apePaterno + " " + element.apeMaterno + ", " + element.nombres;
                });
                setUsuarioLA(result.data);
                setOpenModalLoader(false);
            }
        } catch (error) {
            console.log(`Error en getUsuarioLA: ${error}`);
        }
    };

  
    const filterOption = (input, option) => {
        if (option && typeof option.children === "object" && option.children) {
            return option.children.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        } else if (option && typeof option.children === "string") {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
        return false;
    };



    return (
        <div className="row">
            {/* Columna 1: Nombre y Nombre Corto */}
            <div className="col-md-6">
                <fieldset>
                    <legend style={{ fontSize: "medium" }}>
                        Seleccionar Usuario
                    </legend>
                    <Select
                        style={{ width: "100%", fontSize: "small" }}
                        size="medium"
                        className="select"
                        mode={"single"}
                        popupClassName="my-drop-down"
                        value={infoUsuarioLA?.value || ""}
                        showSearch
                        filterOption={filterOption}
                        onChange={(value, option) => {
                            setInfoUsuarioLA(option);
                            const alreadyExists = usuariosAgregados.some(
                                (user) => user.value === option.value
                            );
                            if (!alreadyExists && option.value !== "") {
                                setUsuariosAgregados((prev) => [...prev, option]);
                            } else if (alreadyExists) {
                                // Mostrar alerta si el usuario ya fue agregado
                                Toast.fire({
                                    icon: "info",
                                    title: "Este usuario ya fue agregado.",
                                });
                            }
                        }}
                    >
                        <Option value={""}>
                            <em>Seleccionar usuario</em>
                        </Option>
                        {usuarioLA
                            ?.filter((opt) => {
                                // Compara con los usuarios ya asignados a la carpeta
                                return !usuarioCarpeta.some((u) => u.id_usuario === opt.id);
                            })
                            .map((opt, idx) => (
                                <Option key={`usuario-${idx}`} value={opt.id}>
                                    {opt.label}
                                </Option>
                            ))}
                    </Select>
                </fieldset>

            </div>
            <div className="col-md-12">
                <BodyUserToFolder
                    usuarioCarpeta={usuarioCarpeta} infoUsuarioLA={infoUsuarioLA}
                    usuariosAgregados={usuariosAgregados}
                    setUsuariosAgregados={setUsuariosAgregados}
                    setOpenModalLoader={setOpenModalLoader} openModalLoader={openModalLoader}
                    getUsersByCarpeta={getUsersByCarpeta} carpetaSeleccionada={carpetaSeleccionada} setInfoUsuarioLA={setInfoUsuarioLA}
                />

            </div>
            <SpinnerLoader open={openModalLoader} />
        </div>
    );
};


export default AddUserToFolderInfo;
